define('app/ss/contact/preferences/ss-contact-preferences',["service!selcomm", "$timeout"], function (SelcommWS, $timeout) {
	"use strict";
		return {
			//model: {
			//	"preferences": "="
			//},
			controller: {
				prototype: {
					bestContactMethods: ["Email", "Post", "Fax"]
				},
				constructor: function () {
					var model = this;
					this._preferences = {
						bestContactMethod: "Email",
						bestContactTime: "Evening"
					}
					var bound = {}
					angular.forEach(this._preferences, function (value, key) {
						bound[key] = Object.create({
							save: function save() {
								model._preferences[key] = this._value;
							}
						}, {
							value: {
								get: function () {
									if ("_value" in this) {
										return this._value;
									}
									else {
										return model._preferences[key];
									}
								},
								set: function (newVal) {
									if (newVal === model._preferences[key]) {
										delete this._value;;
									}
									else {
										this._value = newVal;
									}
								}
							},
							state: {
								get: function () {
									if ("_value" in this) {
										return "update";
									}
									else {
										return "";
									}
								},
								set: function (newVal) {
									if (newVal === "update") {
										this._value = model._preferences[key];
									}
									else {
										delete this._value;;
									}
								}
							}
						});
					});
					this.preferences = bound;
				}
			}
		}
});
